import { lazy } from 'react';
import urlPath from 'src/constants/urlPath';
import { PermissionEn } from '@martech-solution/utils/constants';
import MainLayout from 'src/layouts/MainLayout';
import type { RouteGroup } from '@martech-solution/utils/types';

// Lazy load components
const ApprovalProcess = lazy(() => import('src/pages/Administration/ApprovalProcess'));
const AddApprovalProcess = lazy(() => import('src/pages/Administration/AddApprovalProcess'));
const ApprovalProcessDetail = lazy(() => import('src/pages/Administration/ApprovalProcessDetail'));
const ProposalApprovalProcess = lazy(() => import('src/pages/Administration/ProposalApprovalProcess'));
const AddProposalApprovalProcess = lazy(() => import('src/pages/Administration/AddProposalApprovalProcess'));
const ProposalApprovalProcessDetail = lazy(() => import('src/pages/Administration/ProposalApprovalProcessDetail'));
const Template = lazy(() => import('src/pages/Administration/Template'));
const AddTemplate = lazy(() => import('src/pages/Administration/AddTemplate'));

export const administrationRoutes: RouteGroup = [
  {
    path: urlPath.template.location,
    Layout: MainLayout,
    Component: Template,
    checkPath: urlPath.template.location
  },
  {
    path: `${urlPath.templateEdit.location}/:id`,
    Layout: MainLayout,
    Component: AddTemplate,
    permission: PermissionEn.update
  },
  {
    path: urlPath.templateAdd.location,
    Layout: MainLayout,
    Component: AddTemplate,
    permission: PermissionEn.create
  },
  {
    path: urlPath.approvalProcess.location,
    Layout: MainLayout,
    Component: ApprovalProcess,
    checkPath: urlPath.approvalProcess.location
  },
  {
    path: urlPath.approvalProcessAdd.location,
    Layout: MainLayout,
    Component: AddApprovalProcess,
    permission: PermissionEn.create
  },
  {
    path: `${urlPath.approvalProcessDetail.location}/:id`,
    Layout: MainLayout,
    Component: ApprovalProcessDetail,
    permission: PermissionEn.create
  },
  {
    path: `${urlPath.approvalProcessEdit.location}/:id`,
    Layout: MainLayout,
    Component: AddApprovalProcess,
    permission: PermissionEn.update
  },
  {
    path: urlPath.proposalApprovalProcess.location,
    Layout: MainLayout,
    Component: ProposalApprovalProcess,
    checkPath: urlPath.proposalApprovalProcess.location
  },
  {
    path: urlPath.proposalApprovalProcessAdd.location,
    Layout: MainLayout,
    Component: AddProposalApprovalProcess,
    permission: PermissionEn.create
  },
  {
    path: `${urlPath.proposalApprovalProcessEdit.location}/:id`,
    Layout: MainLayout,
    Component: AddProposalApprovalProcess,
    permission: PermissionEn.update
  },
  {
    path: `${urlPath.proposalApprovalProcessDetail.location}/:id`,
    Layout: MainLayout,
    Component: ProposalApprovalProcessDetail,
    permission: PermissionEn.create
  }
];
